import { render, staticRenderFns } from "./MfTable.vue?vue&type=template&id=644a0ed9&scoped=true&"
import script from "./MfTable.vue?vue&type=script&lang=js&"
export * from "./MfTable.vue?vue&type=script&lang=js&"
import style0 from "./MfTable.vue?vue&type=style&index=0&id=644a0ed9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644a0ed9",
  null
  
)

export default component.exports